import './Payment.scss';

import ReactModal from 'react-modal';
import { useDispatch, useSelector } from 'react-redux';

import Button from 'atoms/button';
import { toggleCheckoutSuccessModal } from 'store/reducers/ui';

export default function AppointmentCompletedModal() {
  const dispatch = useDispatch();
  const { checkoutSuccessModal } = useSelector((state) => state.ui);
  const { user, service, isOpen } = checkoutSuccessModal;

  const onCloseModal = () => {
    dispatch(
      toggleCheckoutSuccessModal({
        isOpen: false,
        user: {
          firstName: null,
          lastName: null,
        },
        service: {
          name: null,
          amount: null,
        },
      })
    );
  };
  return (
    <ReactModal
      ariaHideApp={false}
      isOpen={isOpen}
      className="checkout-success-modal"
      onRequestClose={onCloseModal}
    >
      <div className="flex-column align-center checkout-success-modal-content">
        <h2 className="f20 mb-12">Payment confirmed</h2>
        <p className="f15 text-center mb-28">
          We’ve processed a payment for {user.firstName} {user.lastName} of{' '}
          {service.amount} for {service.name}.
        </p>
        <Button text="Done" size="medium" onClick={onCloseModal} />
      </div>
    </ReactModal>
  );
}
